module.exports = __webpack_public_path__ + "static/media/coffee-latte-dt-fr.ec98d824.jpg";